import React, { useState } from "react";

function HelloReact({ name = "World" }) {
  const [count, setCount] = useState(0);

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-900">Hello, {name}!</h3>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
          React Active
        </span>
      </div>
      <p className="text-sm text-slate-600 mb-4">
        This component demonstrates React integration with the design system.
      </p>
      <div className="flex items-center gap-3">
        <button
          onClick={() => setCount(count + 1)}
          className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-150"
        >
          Increment
        </button>
        <button
          onClick={() => setCount(0)}
          className="inline-flex items-center px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-150"
        >
          Reset
        </button>
        <span className="text-2xl font-semibold text-slate-900 ml-auto">
          {count}
        </span>
      </div>
    </div>
  );
}

export default HelloReact;
